import { redirect } from "react-router-dom";

export async function action({ request }) {
  const fd = await request.formData();
  const choice = fd.get("choice");

  if (choice === "yes") {
    localStorage.setItem("cm_age_ok", "1");
    const hasLang = !!localStorage.getItem("cm_lang");
    return redirect(hasLang ? "/" : "/language");
  }

  localStorage.removeItem("cm_age_ok");
  return redirect("/underage");
}
